export default {"src":"/_next/static/media/attachment-pin-icon.54cbabae.svg","height":513,"width":512};